import { create } from "zustand";
import { apiKeyData, CommonResponseModel, UserMeResponseDataModel } from "../models/axiosModel";
import agent from "../services/api";
import { formatDateAccordingToTimezoneUsingMoment } from "../utils/constants";

interface apiKeyStoreInterface {
    apikeyData: apiKeyData[] | null,
    setApikeyData: (value: apiKeyData[] | null) => void,

    getApiKeyApi: (userDetail: UserMeResponseDataModel) => Promise<CommonResponseModel<apiKeyData>>,

    flagCreateApiKeyPopup: boolean,
    setFlagCreateApiKeyPopup: (value: boolean) => void,

    flagSaveApiKeyPopup: boolean,
    setFlagSaveApiKeyPopup: (value: boolean) => void,

    secretApiKey: string | null,
    setSecretApiKey: (value: string | null) => void
}

export const useApiKeyStore = create<apiKeyStoreInterface>((set) => ({

    apikeyData: null,
    setApikeyData: (value: apiKeyData[] | null) => set({ apikeyData: value }),

    getApiKeyApi: async (userDetail: UserMeResponseDataModel) => {
        const res = await agent.getApiKey.get();

        if (res.status) {

            const normalizedApiKeyData = res?.data?.map((data: apiKeyData, index: number) => {
                return {
                    ...data,
                    index: index + 1,
                    created_at_timestamp: formatDateAccordingToTimezoneUsingMoment(data.created_at_timestamp, userDetail.timezone_hour),
                    api_key_value: "ext-*******"
                }
            })

            set({ apikeyData: normalizedApiKeyData });
        } else {
            set({ apikeyData: null });
        }
        return res;
    },

    flagCreateApiKeyPopup: false,
    setFlagCreateApiKeyPopup: (value: boolean) => set({ flagCreateApiKeyPopup: value }),

    flagSaveApiKeyPopup: false,
    setFlagSaveApiKeyPopup: (value: boolean) => set({ flagSaveApiKeyPopup: value }),

    secretApiKey: null,
    setSecretApiKey: (value: string | null) => set({ secretApiKey: value })

}))